class Fornecedor{
  constructor(){
    this.id = null;
    this.nome = '';
    this.cnpj = '';
    this.endereco = '';
    this.cnpjAndNomeFornecedor = '';

    //JOINS
    this.idCliente = null;
    this.idContribuinteCadastro = null;
  }
}

export default Fornecedor;